import type { ReactElement } from 'react';
import { useState, isValidElement, cloneElement } from 'react';
import { Layout } from 'antd';
import styles from '@/styles/chat.module.css';
import Footer from '@/components/Footer';

const { Sider, Content } = Layout;

const ChatLayout = ({ children }: any) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={styles.chatpage}>
      <Sider
        width={'20%'}
        collapsedWidth={48}
        style={{
          margin: collapsed ? '20px 0 0 20px' : '0',
          alignSelf: collapsed ? 'flex-start' : undefined,
          height: collapsed ? 'auto' : undefined,
          flex: collapsed ? '0 0 auto' : undefined,
        }}
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
      >
        {isValidElement(children[0])
          ? cloneElement(children[0] as ReactElement<any>, {
              collapsed,
              setCollapsed,
            })
          : null}
      </Sider>
      <Layout
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minWidth: 0,
        }}
      >
        <Content
          style={{
            margin: '16px',
            background: '#fff',
            padding: 24,
            overflow: 'auto',
          }}
        >
          {children[1]}
        </Content>
        <Footer />
      </Layout>
    </div>
  );
};

export default ChatLayout;
